import {useReducer} from 'react';

import {ScreenConfig} from './types';

type ScreenActive = ScreenConfig | null;

type Direction = 'next' | 'prev' | null;

export type State = {
	isPaused: boolean
	swipeAnimate: boolean
	swipeDirection: Direction
	swipeX: number

	screens: ScreenConfig[]
	actives: ScreenActive[]
	index: number
	onClose?: () => void
};

export type SwipeAction = {
	type: 'SET_SWIPE',
	animate?: boolean,
	direction?: Direction,
	swipeX: number
  }

export type Action =
  | { type: 'SET_SCREENS', screens: ScreenConfig[] }
  | { type: 'NEXT_SCREEN' }
  | { type: 'PREVIOUS_SCREEN' }
  | { type: 'TOGGLE_PAUSE', paused: boolean }
  | SwipeAction
 ;

const pick = (screens: ScreenConfig[], index: number): ScreenActive[] => {
	const actives = [];
	const arounds = 1;

	for (let i = index - arounds; i <= index + arounds; i++) {
		if (i < 0 || i >= screens.length) {
			actives.push(null);
		} else {
			actives.push(screens[i]);
		}
	}

	return actives;
};

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'SET_SWIPE': {
		return {
			...state,
			swipeAnimate: action.animate || false,
			swipeDirection: action.direction || null,
			swipeX: action.swipeX,
		};
	}

	case 'NEXT_SCREEN': {
		if (state.index >= state.screens.length - 1) {
			return state;
		}
		return {
			...state,
			index: state.index + 1,
			actives: pick(state.screens, state.index + 1),
		};
	}

	case 'PREVIOUS_SCREEN': {
		if (state.index <= 0) {
			return state;
		}
		return {
			...state,
			index: state.index - 1,
			actives: pick(state.screens, state.index - 1),
		};
	}

	case 'TOGGLE_PAUSE': {
		return {
			...state,
			swipeAnimate: state.swipeAnimate && !action.paused,
			isPaused: action.paused,
		};
	}

	case 'SET_SCREENS':
		return {
			...state,
			index: 0,
			screens: action.screens,
			actives: pick(action.screens, 0),
		};
	}
};

export const useState = (
	onClose?: () => void,
) => useReducer(reducer, {
	isPaused: false,
	swipeAnimate: false,
	swipeDirection: null,
	swipeX: 0,

	screens: [],
	actives: [],
	index: 0,
	onClose,
});
